<template>
    <table-page @update:nodeBut="nodeBut">
        <auth ref="addAuthRef" />
    </table-page>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive } from 'vue'
    import TablePage from '../../common/table'
    import Auth from './auth'

    export default defineComponent({
        components: {
            TablePage,
            Auth
        },
        setup() {
            const { proxy } = getCurrentInstance()
            const addAuthRef = ref()
            const nodeBut = (e, data, index) => {
                if (e === 'Auth') {
                    addAuthRef.value.edit(data.id)
                }
            }

            return {
                nodeBut,
                addAuthRef
            }
        }
    })
</script>
<style>
    .database-page .data-table .el-table__body-wrapper {
        height: calc(100vh - 325px);
    }
</style>
